module.exports = __webpack_public_path__ + "static/media/Bank_Statement.cb6e14be.png";